import React from "react";
import { useTranslation } from 'react-i18next';

const CustomBanner = ({ orderNumber,area }) => {
    const { t } = useTranslation();

  return (
    <div
      className={`flex w-full items-center justify-between p-2 lg:py-4 lg:px-4 rounded-sm shadow-md bg-custom-yellow text-black`}
    >
        {/* Order Number */}
        <div className="font-bold">
        <span className="text-sm text-gray-800">{t("orderNumber")} :</span>
        <span className="text-sm text-gray-800" > {orderNumber}</span>
      </div>
      {/* Message */}
      <div className="font-bold">
        <span className="text-sm text-gray-800">{t("Area")}: </span>
        <span className="text-sm text-gray-800">{t(`${area}`)}</span>
      </div>  
  </div>
  );
};

export default CustomBanner;
